import React from "react"
import AgentFormWrapper from "../../../AgentFormWrapper/AgentFormWrapper"
import DocLink from "../../../DocLink/DocLink"
import DebouncedValidatableInput from "../../../ValidatableInput/DebouncedValidatableInput"
import { nameof, nameof2 } from "../../../../utility/common/nameof"
import { AgentValues } from "../../../../models/agent"
import { ParamValues } from "../../../../models/parameterDeclaration"
import { FormikAgentFormProps } from "../../AgentForm"
import PostScoreArticleSelect from "../../../PostScoreArticleSelect/PostScoreArticleSelect"

const tNamespace = "agent:form.scoreagent."
const tFormNamespace = "agent:form."
const tLinkNamespace = "agent:link."

const FormikScoreAgentFormGeneral: React.FC<FormikAgentFormProps> = props => {
    const { asyncState, agentType, t, handleSubmit, disabled } = props

    return (
        <AgentFormWrapper
            agentType={agentType}
            onSubmit={handleSubmit}
            disabled={disabled}
            loading={asyncState.inProcess}
        >
            <DocLink type={agentType}>{t(`${tLinkNamespace}creating-agent-instructions`)}</DocLink>
            <div className="agent-form__section">
                <DebouncedValidatableInput
                    id="formScoreAgentTitle"
                    type="text"
                    name={nameof<AgentValues>("Id")}
                    label={t(`${tFormNamespace}title`)}
                />
                <PostScoreArticleSelect
                    label={t(`${tNamespace}post-score-article`)}
                    name={nameof2<AgentValues, ParamValues>("Params", "post_score_article")}
                />
            </div>
        </AgentFormWrapper>
    )
}

export default FormikScoreAgentFormGeneral
